// NATIVE 
import * as React from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material';



// CUSTOM 
import { eachWordUpper, userHasPermissionFormated } from '../../../commons/utils';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IModulesPermissions } from '../../../commons/interfaces';
import { useNavigate } from 'react-router-dom';




export const  EditarModulosCliente = (props:any) => {


   const navigate = useNavigate();


  const formikProps:any = useFormikContext();

  

  const theme = useTheme();


  // REDUX 
  const { customer }:any  = useSelector( (state:any) => state.customer );
  const { permissions }:any  = useSelector( (state:any) => state.permissions );

  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [pemisssionsList, setPermissionsList] = React.useState([]);
  const [modules, setModules] = React.useState<any>([]);

  // PUT NAME MODULE MAIN MODULE PERMISSIONS 
  const [mainCheck, setMainCheck] = React.useState<any>([]);

  // PUT NAME SUB MODULE PERMISSIONS ACTIONS
  const [actionCheck, setActionCheck] = React.useState<any>([]);


  const [pemisssionsListFormated, setPermissionsListFormated] = React.useState([]);
  


  React.useEffect(() => {
    setPermissionsList(permissions);
  }, [permissions]);
  

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };


  
    React.useEffect(() => {
  
  
    if (customer) {

        formatPermissionsData(permissions, customer).then(  async function(result) {

             await setPermissionsListFormated(result);
              
        });
    }

      
  }, [customer]);

  const formatPermissionsData = async( permissions:any, customer:any ) => {
  
        return await userHasPermissionFormated(permissions, customer);
  
  }



    React.useEffect(() => {

          // BUSCA SI EL MODULO PRINCIPAL ESTA ACTIVADO PARA METER LA PROPIEDAD RELATED DEL OBJETO 
          // EN EL setMainCheck Y ASI EN LA VISATA ACTIVA Y DESACTIVA LLEVANDO EL MISMO FORMATO QUE SE USA 
          // AL HACER CLICK 

          let subModules:any  = [];
          let childrensModules:any  = [];

          pemisssionsListFormated.map( async function (item:any) {
             
              const isActive = item.isChecked;
              // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
              if ( isActive ) {

                   subModules.push(item.related)
                
              }

              // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
              if ( isActive ) {
                   
                   item.childrens.map( async function(children:any) {
                    
                    // VEIFICA QUE EL ITEM DE CHILDREN ESTE CHECKEADO ESTO SE HACE EN EL FORMATER ANTES 
                    if (children.isChecked) {
                        childrensModules.push(children.slug);
                    }
                    
                   });
              }

              

              const { text, icon, permission_slug, permisssion_description, related } = item;

              const permissions = {
                text,
                icon,
                permission_slug,
                permisssion_description,
                related,
                childrens: []
              }

              // IF THE CHECKBOX IS ACTIVE AND NOT EXIST ELEMENT PUSH ELEMENT TO ARRAY 
              if ( isActive && !modules.find((element:any) => element.related === related ) ) {

                await setModules([...modules, permissions]);

              }

              // IF THE CHECKBOX IS NOT ACTIVE AND EXIST THE ELEMENT IN ARRAY REMOVE THE ELEMENT 
              if ( !isActive && modules.find((element:any) => element.related === related ) ) {

                const filteredPermissions = modules.filter(function(el:IModulesPermissions) { return el.related != related; });

                await setModules(filteredPermissions);

              }



          });
          setMainCheck(subModules);
          setActionCheck(childrensModules);



    }, [pemisssionsListFormated]);
  


  React.useEffect(() => {
      
      if ( !customer || Object.keys(customer).length == 0 ) {
            navigate("/manager/clientes");
      }

  }, [customer]);

  
  const  setModulesPermissionsParent  = async(event:any, item:IModulesPermissions) => {

    const isActive = event.target.checked;



    const { text, icon, permission_slug, permisssion_description, related } = item;
    const permissions = {
       text,
       icon,
       permission_slug,
       permisssion_description,
       related,
       childrens: []
    }

    // IF THE CHECKBOX IS ACTIVE AND NOT EXIST ELEMENT PUSH ELEMENT TO ARRAY 
    if ( isActive && !modules.find((element:any) => element.related === related ) ) {

        await setModules([...modules, permissions]);

    }

    // IF THE CHECKBOX IS NOT ACTIVE AND EXIST THE ELEMENT IN ARRAY REMOVE THE ELEMENT 
    if ( !isActive && modules.find((element:any) => element.related === related ) ) {

      const filteredPermissions = modules.filter(function(el:IModulesPermissions) { return el.related != related; });

      await setModules(filteredPermissions);

    }

  
    // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
    if ( isActive ) {

        const depeedItem = JSON.parse(JSON.stringify(mainCheck));
        depeedItem.push(related)
        await setMainCheck(depeedItem);

    }


    // IF THE CHECKBOX IS INACTIVE TO INACTIVE SUB MODULES
    if ( !isActive ) {
      
      let depeedItem = JSON.parse(JSON.stringify(mainCheck));
      let element = depeedItem.indexOf(related);
      if (element !== -1) {
          depeedItem.splice(element, 1);
      }

      await setMainCheck(depeedItem);

    }

    

  } 


  const setModulesPermissionsChildren = async(event:any, item:any, parent:string) => {

    const isActive = event.target.checked;
  
  

     // IF THE CHECKBOX IS ACTIVE AND EXIST ELEMENT PUSH CHILDRENS  ARRAY 
    if ( isActive && modules.find((element:any) => element.related === parent ) ) {


      let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
            
            if ( obj.related == parent ) {
                 const depeedItem = JSON.parse(JSON.stringify(item));
                 depeedItem.parent = parent;
                 depeedItem.actions = [];
                 obj.childrens.push(depeedItem);
            }

            return obj;
        });

        await setModules(filteredPermissions);

    }



    // IF THE CHECKBOX IS NOT ACTIVE AND  EXIST ELEMENT PUSH ELEMENT TO ARRAY 
    if ( !isActive && modules.find((element:any) => element.related === parent ) ) {

      let filteredPermissions = modules.map(function (obj:IModulesPermissions, index:any) {
            
        if ( obj.related == parent ) {
               

              for (let index = 0; index < obj.childrens.length; index++) {
                
                  if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                       obj.childrens.splice(index, 1);
                  }

              }

        }

        return obj;

      });

       await setModules(filteredPermissions);


    }




    // IF THE CHECKBOX IS ACTIVE TO ACTIVE SUB MODULES
    if ( isActive ) {

      const depeedItem = JSON.parse(JSON.stringify(actionCheck));
      depeedItem.push(item.slug)
      setActionCheck(depeedItem);

  }


  // IF THE CHECKBOX IS INACTIVE TO INACTIVE SUB MODULES
  if ( !isActive ) {
    
    let depeedItem = JSON.parse(JSON.stringify(actionCheck));
    let element = depeedItem.indexOf(item.slug);
    if (element !== -1) {
        depeedItem.splice(element, 1);
    }

    setActionCheck(depeedItem);

  }
    

  }



  const setModulesPermissionsChildrenAction =  async(event:any, item:any, parent:string, action: string) => {

      const isActive = event.target.checked;


          // IF THE CHECKBOX IS ACTIVE AND EXIST ELEMENT PUSH CHILDRENS ACTIONS  ARRAY 
      if ( isActive && modules.find((element:any) => element.related === parent ) ) {


        let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
              
              if ( obj.related == parent ) {
                  
                  for (let index = 0; index < obj.childrens.length; index++) {
                  
                    if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                         obj.childrens[index].actions.push(action);
                    }

                  }

              }

              return obj;
          });

          await setModules(filteredPermissions);

      }






      // IF THE CHECKBOX IS NOT ACTIVE AND  EXIST ELEMENT PUSH ELEMENT REMOVE CHILDRENS ACTIONS  ARRAY 
      if ( !isActive && modules.find((element:any) => element.related === parent )  ) {


        let filteredPermissions = modules.map(function (obj:IModulesPermissions) {
              
              if ( obj.related == parent ) {
                  
                  for (let index = 0; index < obj.childrens.length; index++) {
                  
                    if ( obj.childrens[index].text.toLowerCase() == item.text.toLowerCase() ) {
                        
                        const element = obj.childrens[index].actions.indexOf(action);
                        if (element !== -1) {
                          obj.childrens[index].actions.splice(index, 1);
                        }

                    }

                  }

              }

              return obj;
          });

          await setModules(filteredPermissions);

      }


        
  }


  React.useEffect(() => {
     formikProps.setFieldValue('e_permissions', modules);
  }, [modules])
  

  

  return (


    <div>


            {

              pemisssionsListFormated.map((item:any, index:any) => ( 

                

                <>
                  {
                    
                    item.childrens.length > 0 
                    ?
                      
    
                      <Card   sx={{  marginTop: 10, borderTop: 2, borderColor: '#192a56'  }} key={index}>
                        <Card >
                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                              <CardContent sx={{ flex: '1 0 auto' }}>
                                <Typography component="div" variant="h5">
                                  { eachWordUpper(item.text) } <VerifiedIcon/>
                                  {/* { JSON.stringify(item) } */}
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  component="div"
                                  sx={{ color: 'text.secondary' }}
                                >
                                  { eachWordUpper('Sub modulos y permisos') }
                                </Typography>
                              </CardContent>
                            
                              <div > 

                                {/* PERMISOS MODULO PADRE  */}
                                <>
                                    <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                        <div style={{ display: 'flex',  lineHeight: 0 }}>
                                            <FormGroup>
                                              <FormControlLabel control={<Checkbox defaultChecked={ item.isChecked }  onChange={ (e) => setModulesPermissionsParent(e, item) }   name={`mod_${item.permission_slug}`} />} label={'Habilitar modulo aaa'} />
                                            </FormGroup>
                                        </div>
                                    </Box>
                                </>
                                {/* FIN PERMISOS MODULO PADRE  */}

                                
                                  {item.childrens.map((element:any, indexf:any) => ( 

                                    <Accordion expanded={true} onChange={handleChange('panel1')} >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>

                                      
                                      

                                      <Box sx={{  display: 'flex', flexDirection: 'row' }}>
                                        <CardContent sx={{ flex: '1 0 auto' }}>
                                          <Typography component="div" variant="h5">
                                            {/* ELEMENT CHILDREN  */}
                                            { eachWordUpper(element.text) }
                                          </Typography>
                                          <Typography
                                            variant="subtitle1"
                                            component="div"
                                            sx={{ color: 'text.secondary' }}>
                                            {/* ELEMENT PARENT KNOWS PARENT MODULE TEXT  */}
                                            { eachWordUpper(item.text) }
                                          </Typography>
                                          <Typography
                                            variant="subtitle1"
                                            component="div"
                                            sx={{ color: 'text.secondary' }}
                                          >
                                          </Typography>
                                          
                                        </CardContent>
                                        <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                   <FormGroup>                                                                                                               {/* mainCheck es un hook que se le asigna el valor cuando se da click verifica si existe o no y se pone el id */}
                                                    <FormControlLabel control={<Checkbox  defaultChecked={ element.isChecked } inputProps={{ 'aria-label': 'controlled' }}   disabled={ mainCheck.includes(item.related) ? false : true }  onChange={ (e) => setModulesPermissionsChildren(e, element, item.related) }   name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                  </FormGroup>
                                              </div>
                                        </Box>
                                        
                                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                        
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox defaultChecked={ element.actions ? element.actions.includes('view') : false } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'view') }   name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox defaultChecked={ element.actions ? element.actions.includes('create') : false } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'create') }   name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox defaultChecked={ element.actions ? element.actions.includes('edit') : false } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'edit') }   name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox defaultChecked={ element.actions ? element.actions.includes('delete') : false } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'delete') }   name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                </FormGroup>
                                              </div>
                                              <div style={{ display: 'flex',  lineHeight: 0 }}>
                                               <FormGroup>
                                                  <FormControlLabel control={<Checkbox defaultChecked={ element.actions ? element.actions.includes('restore') : false } disabled={ actionCheck.includes(element.slug) ? false : true } onChange={ (e) => setModulesPermissionsChildrenAction(e, element, item.related, 'restore') }   name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                </FormGroup>
                                              </div>
                                        </Box>
                                      </Box>
                                  
                                      </AccordionDetails>
                                    </Accordion>
                                  ))}


                                
                                
                              </div>
                          </Box>
                        </Card>
                      </Card>
                    :
                    ''
                  }
                   
   
                   
                </>
                
              ))

            }

    </div>
    
  );
}